import useCreateTaskAnva from '../mutations/useCreateTaskAnva';
import useExportPartyToAnva from '../mutations/useExportPartyToAnva';
import useUploadDocumentAnva from '../mutations/useUploadDocumentAnva';

export default function useActionsAnva() {
  const { mutateAsync: createTask } = useCreateTaskAnva();
  const { mutateAsync: exportParty } = useExportPartyToAnva();

  const { mutateAsync: uploadDocument } = useUploadDocumentAnva();

  return {
    createTask,
    exportParty,
    uploadDocument,
  };
}
